// Node.js globals polyfill for browser (Vite doesn't auto-polyfill like Webpack)
// Must be imported before any modules that depend on Buffer (e.g. AWS API Gateway client)
import { Buffer } from 'buffer'
if (typeof window.Buffer === 'undefined') { window.Buffer = Buffer }
